module.exports = __webpack_public_path__ + "media/question4_en.1991bcee.mp3";